import { Typography } from '@eventbrite/marmalade';
import styles from './TimeRange.module.scss';
import { parse, format } from 'date-fns';

interface Props {
  startTime?: string;
  endTime?: string;
}

export const TimeRange: React.FC<Props> = ({ startTime, endTime }) => {
  if (!startTime) {
    return null;
  }

  const separator = endTime ? <span className={styles.time}> - </span> : null;
  const endTimeElement = endTime ? (
    <time dateTime={endTime} className={styles.time}>
      {formatTime(endTime)}
    </time>
  ) : null;
  return (
    <Typography as="p" className={styles.timeRange}>
      <time dateTime={startTime} className={styles.time}>
        {formatTime(startTime)}
      </time>
      {separator}
      {endTimeElement}
    </Typography>
  );
};

function formatTime(time: string) {
  const date = parse(time, 'HH:mm', new Date());
  return format(date, 'hh:mm a');
}
